import { call, put } from 'redux-saga/effects';
import { maintenanceConfigError, setMaintenanceConfig, setSettingsConfig, settingsConfigError } from '../../entities/configs';
import { requestGetMaintenanceConfig, requestGetSettingsConfig } from '../requests/configs';

export function* handleGetMaintenanceConfig(action) {
    try {
        const response = yield call(requestGetMaintenanceConfig, action.payload);
        const { data } = response;
        yield put(setMaintenanceConfig({ ...data }));
    } catch (error) {
        console.log(error, 'this is get maintenance config error');
        yield put(maintenanceConfigError());
    }
}

export function* handleGetSettingsConfig(action) {
    try {
        const response = yield call(requestGetSettingsConfig, action.payload);
        const { data } = response;
        yield put(setSettingsConfig({ ...data }));
    } catch (error) {
        console.log(error, 'this is get maintenance config error');
        yield put(settingsConfigError);
    }
}
